import { EmotionIconProps } from '@emotion-icons/emotion-icon'

export const ZoningIcon = (props: EmotionIconProps) => {
  const { fill, color, size } = props
  return (
    <svg height={size} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 0.200195H0V9.20972H9.49669L11.5143 4.71008H18V0.200195Z" fill={fill || color || 'currentColor'} />
      <path d="M18 6.21008H12.4856L7.10921 18.2002H18V6.21008Z" fill={fill || color || 'currentColor'} />
      <path d="M5.46531 18.2002L8.82408 10.7097H0V18.2002H5.46531Z" fill={fill || color || 'currentColor'} />
    </svg>
  )
}
